import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link as RouterLink } from 'react-router-dom';
import { ThemeProvider, CssBaseline, AppBar, Toolbar, IconButton, Drawer, List, ListItemButton, ListItemText, Typography, Box, Button } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import theme from './theme';
import ChatWindow from './components/ChatWindow';
import HealthCanvas from './pages/HealthCanvas';
import Bookmarks from './pages/Bookmarks';
import Auth from './pages/Auth';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import CommunityChat from './pages/CommunityChat';

function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
        {/* Top Navigation Bar with Hamburger Menu and Brand */}
        <AppBar
          position="fixed"
          sx={{
            backgroundColor: '#000000',
            color: '#EAD7B2',
            borderBottom: '0.25px solid #EAD7B2',
            boxShadow: 'none',
          }}
        >
          <Toolbar sx={{ px: { xs: 1.5, sm: 0 } }}>
            <Box
              sx={{
                width: '100%',
                maxWidth: { xs: '100%', sm: 720 },
                mx: 'auto',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {/* Hamburger Menu Button */}
              <IconButton edge="start" color="inherit" onClick={() => setMenuOpen(true)}>
                <MenuIcon />
              </IconButton>

              {/* Centered Brand Name "Kōkūn" */}
              <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
                <Typography variant="h6" fontWeight="bold">
                  Kōkūn
                </Typography>
              </Box>
              {/* Right-side account action */}
              <AccountAction />
            </Box>
          </Toolbar>
        </AppBar>
        {/* Spacer to offset fixed AppBar height */}
        <Toolbar sx={{ mb: 0 }} />

        {/* Sidebar Navigation */}
        <Drawer anchor="left" open={menuOpen} onClose={() => setMenuOpen(false)}>
          <Box sx={{ width: 280 }}>
            <Toolbar />
            <List>
              <ListItemButton component={RouterLink} to="/" onClick={() => setMenuOpen(false)}>
                <ListItemText primary="Chat Assistant" />
              </ListItemButton>
              <ListItemButton component={RouterLink} to="/community-chat" onClick={() => setMenuOpen(false)}>
                <ListItemText primary="Community Chat" />
              </ListItemButton>
              <ListItemButton component={RouterLink} to="/health-canvas" onClick={() => setMenuOpen(false)}>
                <ListItemText primary="Health Canvas" />
              </ListItemButton>
              <ListItemButton component={RouterLink} to="/book-marks" onClick={() => setMenuOpen(false)}>
                <ListItemText primary="Bookmarks" />
              </ListItemButton>
              <ListItemButton component={RouterLink} to="/auth" onClick={() => setMenuOpen(false)}>
                <ListItemText primary="Sign in / Account" />
              </ListItemButton>
            </List>
          </Box>
        </Drawer>

        {/* Center content with max width on larger screens, full width on phones */}
        <Box
          sx={{
            width: '100%',
            maxWidth: { xs: '100%', sm: 720 },
            mx: 'auto',
            px: { xs: 2, sm: 2 },
            py: { xs: 1, sm: 2 },
          }}
        >
          <Routes>
            <Route path="/" element={<ChatWindow />} />
            <Route path="/community-chat" element={<CommunityChat />} />
            <Route path="/health-canvas" element={<HealthCanvas />} />
            <Route path="/book-marks" element={<Bookmarks />} />
            <Route path="/auth" element={<Auth />} />
          </Routes>
        </Box>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

function AccountAction() {
  const { user, signOut } = useAuth();
  if (!user) {
    // Keep width similar to an icon button to preserve centering
    return (
      <Box sx={{ width: 90, display: 'flex', justifyContent: 'flex-end' }}>
        <Button component={RouterLink} to="/auth" color="inherit" size="small">
          Sign in
        </Button>
      </Box>
    );
  }
  return (
    <Box sx={{ width: 140, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 1 }}>
      <Typography variant="body2" sx={{ display: { xs: 'none', sm: 'block' } }}>
        {user.email}
      </Typography>
      <Button color="inherit" size="small" onClick={signOut}>Sign out</Button>
    </Box>
  );
}

export default App;
